import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryCode, PortalApiService } from 'src/app/services/portal-api.service';
@Component({
  selector: 'app-county-code-dropdown',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './country-code-dropdown.component.html',
  styleUrl: './country-code-dropdown.component.css'
})
export class CountryCodeDropdownComponent {
  @Input() countryCode?: string;
  protected selected: any | undefined;
  @Output() DropdownSelected: EventEmitter<string> = new EventEmitter<string>();

  hideDropdown: boolean = true;
  flag: string | undefined;
  countryCodes?: CountryCode[];

  constructor(
    private portalAPi: PortalApiService
  ) {
  }

  ngOnInit() {
    this.portalAPi.getCountryCodes().subscribe({
      next: (res) => {
        this.countryCodes = res;
        if (this.selected) {
          this.flag = res?.find(x => x.twoLetterCode == this.selected)?.twoLetterCode?.toLocaleLowerCase();
        }else{
          this.flag = res?.find(x => x.callingCode == this.countryCode?.replace('+',''))?.twoLetterCode?.toLocaleLowerCase();
        }
      }
    });
  }

  dropDownSelected(item: CountryCode) {
    this.flag = item.twoLetterCode?.toLocaleLowerCase();
    const code = this.countryCodes ? `+${this.countryCodes?.find((x:any) => x.twoLetterCode.toLocaleLowerCase() == this.flag)?.callingCode}` : '';
    this.DropdownSelected.emit(code);
    this.toggleDropdown();
  }

  toggleDropdown() {
    this.hideDropdown = !this.hideDropdown;
  }

  closeDropdown() {
    this.hideDropdown = true;
  }
}

export interface DropdownItem {
  key: any,
  icon: any,
  label: string,
  countryCode: string
}
